import Button from '@material-ui/core/Button'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import LabelWrapper from '../LabelWrapper'

const Filter = styled(Button)`
  && {
    white-space: nowrap;
    font-weight: normal;
    border: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    min-height: 34px;
    height: 36px;
    line-height: 1;
    min-width: auto;
    > span {
      opacity: 0.7;
    }
    &.active {
      > span {
        opacity: 1;
      }
      font-weight: bold;
    }
    &.MuiButton-text {
      padding: 0 10px;
    }
  }
`

/* eslint-disable react/prefer-stateless-function */
class TableFilterInput extends React.Component {
  render() {
    const {
      children,
      className,
      customMargin,
      customPadding,
      disabled,
      fullWidth,
      isLabelInline,
      justify,
      label,
      notWrapper,
      spacing,
      withBorder,
      withDivider,
      ...rest
    } = this.props
    return (
      <ThemeProvider theme={theme}>
        <LabelWrapper
          customMargin={customMargin}
          customPadding={customPadding}
          disabled={disabled}
          fullWidth={fullWidth}
          isLabelInline={isLabelInline}
          justify={justify}
          label={label}
          notWrapper={notWrapper}
          spacing={spacing}
          withBorder={withBorder}
          withDivider={withDivider}
        >
          <Filter className={className} {...rest}>
            {children}
          </Filter>
        </LabelWrapper>
      </ThemeProvider>
    )
  }
}

TableFilterInput.defaultProps = {
  fullWidth: false,
  notWrapper: true,
  withBorder: true,
  withDivider: false,
}

export default TableFilterInput
